<template>
  <div v-if="exception">
    <h5 class="pb-2 border-bottom" v-if="!hideHeader">
      {{ exception.message }}
    </h5>
    <div>stacktrace:</div>
    <pre class="text-danger mb-3 border3">
          {{ exception.stack }}
    </pre>
  </div>
</template>

<script>
export default {
  props: ["exception", "hideHeader"]
};
</script>
